module.exports = __webpack_public_path__ + "static/img/contant_3.4a35777.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_7/contant_3.png
// module id = Zlrx
// module chunks = 0